import { Splash } from '@salecycle/ui-component-library';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  children: React.ReactNode;
}

export function CampaignPerformanceTab(props: Props) {
  const { t } = useTranslation('campaigns');

  return (
    <>
      <Splash imageHeight={500} imageUrl="/images/no-integrations-splash.svg" heading={t('onsite.comingSoon')} />
    </>
  );
}
